import React from 'react';
import './FooterIcon.css';
import apiRouter from "../utils/apiRouter.json";
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import IconLink from '../Components/Link/IconLinks';

function FooterIcon() {
  return (
    <div className="footer-icon">
      <IconLink
        url={apiRouter.api.contactRoute.github}
        icon={faGithub}
      />
      <IconLink
        url={apiRouter.api.contactRoute.envelope}
        icon={faEnvelope}
      />
      <IconLink
        url={apiRouter.api.contactRoute.linkedin}
        icon={faLinkedin}
      />
    </div>
  );
}

export default FooterIcon;
